<template>
    <div>
        <b-modal
            id="modify-risk-rating-score-popup"
            ref="modal"
            title="Modify Risk Rating Score"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row p-24">
                    <div v-show="formData.criteria" class="col-md-12">
                        <h5 v-if="formData.criteria.code === 'Sanctioned Risk'">
                            {{ formData.criteria.code }}
                        </h5>

                        <h5 v-else class="mb-20">
                            Point Scoring (Initial Range)
                        </h5>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div
                                v-if="formData.rating != 'sanction'"
                                class="col-md-6"
                            >
                                <b-form-group
                                    id="input-group-1"
                                    label="Start"
                                    label-for="Start"
                                >
                                    <b-form-input
                                        id="start-score"
                                        v-model.number="formData.criteria.start"
                                        v-validate="{
                                            required: true,
                                            min: 1,
                                            max: 3,
                                            max_value: 100,
                                            numeric: true,
                                        }"
                                        type="text"
                                        placeholder="Enter start score"
                                        name="startScore"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'startScore'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div
                                v-if="formData.rating != 'sanction'"
                                class="col-md-6"
                            >
                                <b-form-group
                                    id="input-group-2"
                                    label="End"
                                    label-for="End"
                                >
                                    <b-form-input
                                        id="end-score"
                                        v-model.number="formData.criteria.end"
                                        v-validate="{
                                            required: true,
                                            min: 1,
                                            max: 3,
                                            max_value: 100,
                                            numeric: true,
                                        }"
                                        type="text"
                                        placeholder="Enter end score"
                                        name="EndScore"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'EndScore'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Rating"
                            label-for="rating"
                            :class="
                                formData.rating == 'sanction'
                                    ? 'disable-select '
                                    : ''
                            "
                        >
                            <b-form-select
                                v-model="formData.rating"
                                class="form-control"
                                :options="rating"
                            ></b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-4"
                            label="Review Period"
                            label-for="period"
                        >
                            <b-form-input
                                id="period"
                                v-model="formData.reviewPeriod"
                                v-validate="{
                                    required: true,
                                    min_value: 1,
                                    max_value: 999,
                                    min: 1,
                                    max: 3,
                                }"
                                type="text"
                                placeholder="Enter review period"
                                name="reviewPeriod"
                                :class="{
                                    'is-invalid': errors.has('reviewPeriod'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-3"
                            label="Duration"
                            label-for="duration"
                        >
                            <b-form-select
                                v-model="formData.duration"
                                v-validate="{
                                    required: true,
                                }"
                                name="duration"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('duration'),
                                    },
                                ]"
                                :options="duration"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Generate Alert"
                            label-for="generate"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.generateAlert"
                                    :options="generateAlert"
                                    name="generateAlert"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            formData: this.initializeFormData(),

            generateAlert: [
                { text: 'Yes', value: 'true' },
                { text: 'No', value: 'false' },
            ],

            rating: [
                { value: null, text: 'Select Rating', disabled: true },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanctioned' },
            ],
            duration: [
                { value: null, text: 'Select Duration', disabled: true },
                { value: 'month', text: 'Months' },
                { value: 'year', text: 'Years' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        title() {
            return this.selectedItem
                ? 'Modify Risk Factor'
                : 'Add Country of Residence Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                reviewPeriod: '',
                criteria: {
                    start: '',
                    end: '',
                    code: '',
                },
                duration: null,
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    if (this.formData.criteria.code === undefined) {
                        this.formData.criteria.code = null
                    }
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>
